import React, { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import Logos from './Logos'
import Review from './Review'
import Footer from './Footer'
import Form from './Form'

export default function Newform() {
    const [productMake, setproductMake] = useState([])
    const [productModel, setproductModel] = useState([])
    const newMake = useRef('');
    const newURL = useRef('');
  const BASE_URL = 'https://node.insuranceadvisors.pk';

    
    const handleChange = (event) => {
      newMake.current = event.currentTarget.value 
      newURL.current = BASE_URL + '/api/findprd/' + newMake.current
      getAllProductModel()
      event.preventDefault()
    };
    
    const getAllProductModel = async () =>{  
      try{
        await axios.get(newURL.current).then((res) =>{
          setproductModel(res.data)
        }).catch((err) =>{
          console.log(err)
        })
      }catch(error){
        console.log(error)
      }
    }
    
    function getAllProductMake(){
      // var url = 'https://fakestoreapi.com/products'
      var url = BASE_URL + '/api/findprd'
      axios.get(url).then((res) =>{
        // alert(res.data[1])
        setproductMake(res.data)
      }).catch((err) =>{
        console.log(err)
      })
    }
    
    useEffect(()=>{
      getAllProductMake()
    })
    
    
    const [cart, setCart] = useState([]);
      const saveCartItems = (cart) => {
        const saveapi = "http://127.0.0.1:8000/api/saveorder"
        
        cart.map((product)=>
        axios.post(saveapi, {
          id: product.id,
          name: product.name,
          contact: product.contact,
          email: product.email,
          productModel: product.productModel,
          productMake: product.productMake,
          manufacturingYear: product.manufacturingYear,
          estimatedValue: product.estimatedValue
        }).then((res)=>{
          console.log(res)
          alert("Order Confirmed")
          }).catch((err)=>{
          console.log(err)
          alert(err)
          })
        )
      
        
      }
    

  return (
    <div className='container'>
        <br/><br/><hr/>
 <h1 className='pr1'>PLEASE FILL THIS FORM</h1>       
      <hr/>
<form method='POST' action='http://127.0.0.1:8000/api/saveorder'>

<select class="form-control form-control-lg"  list="datalistOptions" name='productMake' placeholder="Car Brand" required
aria-label=".form-control-lg example" onChange={handleChange}>
  <option value='' selected> Choose Your Car Make </option>
  {productMake.map((content) =>(
    <option value={content}> {content} </option>
  ))}
</select>


<br/>
<select class="form-control form-control-lg" name='productModel' value={newMake.current} id="exampleFormControlSelect1" required>
  {productModel.map((content) =>(
    <option value={content.productModel}> {content.productModel} </option>
  ))}
</select>
<br/>
<input class="form-control form-control-lg"  placeholder="Manufacturing Year" required name='manufacturingYear' aria-label=".form-control-lg example"/>
<br/>
<input class="form-control form-control-lg" placeholder="Current Value" required name='estimatedValue' aria-label=".form-control-lg example" />
<br/>
<input class="form-control form-control-lg" type='name' name='name' placeholder="Enter Your Name" aria-label=".form-control-lg example"/>
<br/>

<input class="form-control form-control-lg" type='email' name='email' placeholder="Enter Your Email" aria-label=".form-control-lg example"/>
<br/>

<input class="form-control form-control-lg" type='number' name='contact' placeholder="Enter Your Contact Number" aria-label=".form-control-lg example"/>

<br/><br/><br/>



<div id="d3" >

{/* <a type='submit' href='/car1' class="btn btn-danger btn-lg" id="d2"> Next </a> */}
<button type='submit' class="btn btn-danger btn-lg" id="d2" onClick={() => saveCartItems(cart)} > Next </button>




</div>
</form>

    </div>


  )
}
